// test2041
(2041 && 0);
